import { Box, BoxProps, ColorOptions, Loader, ModalDialogNew, ModBox, Spacer, Text, TextProps } from '@jfs/ui-new'
import { convertHexToRGBA, useIsLargeScreen } from '@jfs/ui-new/src/utils/utils'
import NetInfo from '@react-native-community/netinfo'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { Dimensions, FlatList, Linking, Text as NativeText, Platform, ViewStyle } from 'react-native'
import DeviceInfo from 'react-native-device-info'
import { LinearGradientContainer } from '../../../comps/LinearGradient'
import { SvgImage } from '../../../comps/SvgImage'
import { ToastType } from '../../../comps/Toast'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import {
  Colors,
  getAppId,
  getFromStore,
  isMobile,
  isOsMobile,
  logEvent,
  ScreenLockModule,
  storeData,
} from '../../../util/util'
import { RenderMidList } from '../../Home/RenderMidList'
import Toggle from '../../NotificationSettings/Toggle'
import { newActionData } from '../ProfileTabComponents/ProfileTabsUtilityMapper'
import { PolicyDocumentsModal } from './PolicyDocumentsModal'
import { SelectLanguageModel } from './SelectLanguageModel'
import { VoiceBoxListModal } from './VoiceBoxListModal'

const { height } = Dimensions.get('window')

const ListHeaderComponent = ({ handleSetLock, isAppLockEnabled }) => {
  return (
    <ModBox
      flexDirection={'row'}
      justify="space-between"
      p={16}
      pr={12}
      marginVertical={16}
      borderRadius={8}
      align={'center'}
      show={!!ScreenLockModule}
      marginHorizontal={24}
      bg={convertHexToRGBA(Colors.PRIMARY, 6) as ColorOptions}>
      <Box flexDirection={'row'} align="center">
        <SvgImage imageName="ProtectAccountSmall" color={'#DF9F3A'} textColor={'#FFC467'} />
        <Spacer direction={'horizontal'} size={16} />
        <Box w={192}>
          <Text
            title={'Screen Lock'}
            color={'BLACK'}
            fontFamily={'JioType-Bold'}
            fontSize={14}
            lineHeight={20}
            letterSpacing={-0.07}
          />
          <Text
            title={'Use screenlock to secure your account'}
            color={convertHexToRGBA(Colors.BLACK, 65) as ColorOptions}
            fontFamily={'JioType-Medium'}
            fontSize={12}
            lineHeight={18}
            letterSpacing={-0.06}
          />
        </Box>
      </Box>
      <Spacer direction={'horizontal'} size={16} />
      <Toggle onChange={handleSetLock} toggleValue={isAppLockEnabled} width={28} height={16} radius={4} />
    </ModBox>
  )
}

const NewProfileNative = () => {
  const {
    mobileNumber,
    merchantName,
    logout,
    updateUserDevice,
    sortedMerchants,
    selectedMid,
    updateSelectedMercName,
    updateSelectedMercMid,
    updateselectedMercTid,
    updateSelectedMercMobileNumber,
    updateVpaFromStore,
    isUserManagementEnabled,
    canViewSettlementBankDetails,
    isAppLockEnabled,
    setAppLockEnabled,
    setMessage,
    setToastType,
    searchEntity,
  } = useStores((store) => ({
    mobileNumber: store.settings.metaData.selectedMobileNumber,
    merchantName: store?.settings?.metaData?.selectedMercName,
    logout: store?.user?.session?.logout,
    updateUserDevice: store?.user?.updateUserDevice,
    sortedMerchants: store?.user?.sortedMerchants,
    selectedMid: store?.user?.selectedMid,
    updateSelectedMercName: store.settings.metaData.updateSelectedMercName,
    updateSelectedMercMid: store.user.updateSelectedMercMid,
    updateselectedMercTid: store.user.updateSelectedMercTid,
    updateSelectedMercMobileNumber: store.settings.metaData.updateSelectedMercMobileNumber,
    updateVpaFromStore: store.user.updateVpaFromStore,
    canViewSettlementBankDetails: store.userManagement.canViewSettlementBankDetails(),
    isUserManagementEnabled: store.userManagement.isUserManagementEnabled(),
    resetSelectedDates: store.resetDatesInPaymentTabs,
    isAppLockEnabled: store.settings.metaData.isAppLockEnabled,
    setAppLockEnabled: store.settings.metaData.setAppLockEnabled,
    setMessage: store?.response?.setMessage,
    setToastType: store?.response?.setToastType,
    searchEntity: store?.user?.searchEntity,
  }))

  const [logoutAPI] = useLazyApiData(logout)
  const [updateUserDeviceStatus] = useLazyApiData(updateUserDevice)
  const [isLogoutAlertVisible, setLogoutAlertVisible] = useState(false)
  const [searchEntityApi, { state: searchEntityState, data: searchEntityData }] = useLazyApiData(searchEntity)
  const [showMidList, setMidListVisible] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [isLoggingOut, setLoggingOut] = useState(false)
  const [showLangModal, setShowLangModal] = useState(false)
  const [showPolicyDocumentsModal, setPolicyDocumentsModal] = useState(false)
  const [profileCardHeight, setProfileCardHeight]: any = useState({ height: 230 })
  const [canViewSettlementBankDetail, setCanViewSettlementBankDetail] = useState(canViewSettlementBankDetails)
  const navigation = useNavigation()

  const isLargeScreen = useIsLargeScreen()
  const isSmallDevice = isMobile(isLargeScreen)
  const mobileView = isMobile(!isSmallDevice ?? true)
  const isFocused = useIsFocused()
  const sOsMobile = isOsMobile()
  const merchantList = sortedMerchants()
  // console.log('device list', JSON.parse(JSON.stringify(devices)))

  //const mobile = mobileNumber?.contains('+91') ? `+91 ${mobileNumber.slice(3)}` : `+91 ${mobileNumber}`
  const [isConnected, setIsConnected] = useState(null)

  useEffect(() => {
    const unsubscribe = NetInfo.addEventListener((state) => {
      setIsConnected(state.isConnected)
    })

    // Unsubscribe when the component unmounts
    return () => {
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (isFocused) {
      setLoggingOut(false)
    }
  }, [isFocused])

  useEffect(() => {
    if (searchEntityState === 'fulfilled') {
      console.log('searchEntityData success', searchEntityData)
    } else if (searchEntityState === 'rejected') {
      console.log('searchEntityData failed', searchEntityData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchEntityState])

  useEffect(() => {
    if (selectedMid) {
      searchEntityApi(selectedMid)
    }
  }, [selectedMid])

  const navigateToScreen = (item: any) => {
    logEvent('profile_item_press', item.name)

    if (item?.link) {
      Linking.openURL(item?.link).catch((err) => console.error('An error occurred', err))
    } else if (item?.onPress === Routes.MY_DEVICES) {
      console.log('moahn added for my device')
      if (isConnected) {
        setShowModal(true)
      } else {
        Alert.alert('Internet Connection', 'You are offline. Please Turn on mobile data or connect to a Wifi.')
      }
    } else if (item?.onPress === 'PolicyDocumentsModal') {
      setPolicyDocumentsModal(true)
    } else if (item?.onPress === 'LanguageModal') {
      setShowLangModal(true)
    } else if (item?.onPress !== 'Logout') {
      navigation.navigate(item?.onPress as never, { id: item?.mapID, header: item?.name ?? '' } as never)
    } else {
      setLogoutAlertVisible(true)
    }
  }
  const renderProfileItems = ({ item, index }: any) => {
    return (
      <Box
        underlayColor={'TRANSPARENT'}
        testID={'profile-nav-' + item?.name?.replaceAll(' ', '')}
        onPress={() => navigateToScreen(item)}
        paddingTop={18}
        paddingBottom={18}
        ph={25}
        key={'' + index + item?.index}
        flexDirection="row">
        <SvgImage imageName={item?.icon} color={Colors.SECONDARY} />
        <Spacer size={20} direction="horizontal" />
        <Text fontFamily={'JioType-Medium'} fontSize={16}>
          {item?.name}
        </Text>
      </Box>
    )
  }

  const keyExtractor = (item: any): string => {
    return item?.index
  }

  const getDeviceIdFromLib = () => {
    return DeviceInfo.getUniqueId()
  }

  const callLogoutApi = async () => {
    if (sOsMobile) {
      setLoggingOut(true)
      logEvent('btn_press', 'logout')
      updateUserDeviceStatus(await getDeviceIdFromLib(), getAppId(), 0)
      logoutAPI()
    } else {
      logoutAPI()
    }
  }

  const profileData = newActionData(true, isUserManagementEnabled, sOsMobile)
  const handleCancel = () => {
    logEvent('btn_press', 'cancel_logout')
    setLogoutAlertVisible(false)
  }

  const switchMid = () => {
    logEvent('btn_press', 'switch_mid_profile')
    setMidListVisible(true)
  }

  const getHeight = (event) => {
    setProfileCardHeight(event?.nativeEvent?.layout)
  }

  const handleSetLock = (val: boolean) => {
    if (val) {
      if (ScreenLockModule) {
        ScreenLockModule.openEnableLockScreen(async (value: boolean) => {
          storeData('lockEnabled', value ? 'true' : 'false')
          if (value) {
            logEvent('screenlock_toggled', 'enabled')
            setToastType(ToastType.POSITIVE)
            setMessage('Your account is now secure')
          }
          setAppLockEnabled(value)

          getFromStore('lockState')
            .then((result) => {
              console.log('Async operation completed:', result)

              if (Platform.OS === 'ios' && !value && result === '1') {
                Alert.alert(
                  'Enable screen lock',
                  'The user disallowed screen lock last time, please adhere to the guidelines to enable screen lock -> Settings -> JioPay Business -> Enable Face ID',
                )
              } else if (Platform.OS === 'ios' && !value) {
                storeData('lockState', 1)
              }
            })
            .catch((error) => {
              console.error('Error during async operation:', error)
            })
        })
      }
    } else {
      logEvent('screenlock_toggled', 'disabled')
      storeData('lockEnabled', 'false')
      setAppLockEnabled(false)
    }
  }

  return (
    <Box bg={'SECONDARY'} flex={1}>
      <Box onLayout={getHeight} marginHorizontal={25} mt={25} pb={24} zIndex={5}>
        <LinearGradientContainer
          customStyle={
            {
              //height: 186,
              borderWidth: 1,
              borderColor: Colors.PRIMARY,
              //backgroundColor: Colors.PRIMARY,
              borderRadius: 16,
              overflow: 'hidden',
            } as ViewStyle
          }
          colorArray={['#e09e3a', '#de9f3a']}
          useAngle={true}
          angle={124}
          direction="HORIZONTAL">
          <Box p={24}>
            <Box>
              <ModBox flexDirection={'row'} justifyContent="space-between">
                <ModBox
                  zIndex={9}
                  width={45}
                  height={45}
                  borderRadius={28}
                  left={3}
                  top={3}
                  align="center"
                  justify="center">
                  <ModBox
                    zIndex={11}
                    align="center"
                    justify="center"
                    overflow={'hidden'}
                    borderRadius={28}
                    bg={'PRIMARY'}
                    width={45}
                    height={45}>
                    {sOsMobile ? (
                      <SvgImage width={15} height={19} color="#fff" imageName="Union" />
                    ) : (
                      <SvgImage color="#fff" imageName="ProfileIcon" />
                    )}
                  </ModBox>
                  <Box {...styles.ripple1} zIndex={1} />
                  <Box {...styles.ripple2} zIndex={1} />
                  <Box {...styles.ripple3} zIndex={1} />
                </ModBox>
                <ModBox
                  show={merchantList?.length > 1}
                  flexDirection={'row'}
                  align="flex-start"
                  justify="center"
                  onPress={switchMid}
                  testID="switchMid"
                  underlayColor="TRANSPARENT">
                  <SvgImage imageName="RefreshIcon" />
                  <Text fontFamily={'JioType-Medium'} fontSize={12} color="WHITE">
                    Switch A/c
                  </Text>
                </ModBox>
              </ModBox>
              <Spacer size={16} direction="vertical" />
              <ModBox show={merchantName?.length}>
                <Text fontFamily={'JioType-Black'} fontSize={18} color="WHITE" lineHeight={24} letterSpacing={-0.09}>
                  {merchantName}
                </Text>
                <Spacer size={2} direction="vertical" />
              </ModBox>
              <ModBox show={mobileNumber?.length}>
                <Text fontFamily={'JioType-Medium'} fontSize={14} color="WHITE" lineHeight={20} letterSpacing={-0.07}>
                  {mobileNumber?.includes('+91') ? '+91 ' + mobileNumber.slice(3) : mobileNumber}
                </Text>
              </ModBox>
              <Text fontFamily={'JioType-Medium'} fontSize={12} color="WHITE" lineHeight={20} letterSpacing={-0.06}>
                MID: {selectedMid}
              </Text>
            </Box>
          </Box>
        </LinearGradientContainer>
      </Box>

      <Box
        {...styles.profileListWrapper}
        maxHeight={height - profileCardHeight?.height / 2}
        height={height - profileCardHeight?.height}
        key={'profile_scrollview'}>
        <Box height={Platform.OS === 'android' ? profileCardHeight?.height / 1.5 : profileCardHeight?.height / 3} />
        <FlatList
          data={profileData}
          ListHeaderComponent={
            <ListHeaderComponent handleSetLock={handleSetLock} isAppLockEnabled={isAppLockEnabled} />
          }
          renderItem={renderProfileItems}
          keyExtractor={keyExtractor}
          extraData={profileData}
        />
      </Box>

      {/* select app language */}
      <SelectLanguageModel show={showLangModal} onDismiss={() => setShowLangModal(false)} />

      {/* Policy Documents Modal */}
      <ModalDialogNew
        onBackPress={() => setPolicyDocumentsModal(false)}
        animate={true}
        type="bottom"
        backgroundColor="TRANSPARENT"
        show={showPolicyDocumentsModal}>
        <PolicyDocumentsModal
          onSelect={navigateToScreen}
          title={'Policy Documents'}
          show={showPolicyDocumentsModal}
          onDismiss={() => setPolicyDocumentsModal(false)}
        />
      </ModalDialogNew>

      <ModalDialogNew
        animate={true}
        type="bottom"
        show={isLogoutAlertVisible}
        onDismiss={handleCancel}
        backgroundColor="TRANSPARENT">
        <Box borderTopLeftRadius={24} borderTopRightRadius={24} bg="WHITE" overflow={'hidden'} pv={32} ph={24}>
          <Box w={60} h={60} align="center" justify="center" bg={'#E30513' as ColorOptions} borderRadius={30}>
            <SvgImage imageName="Logout" color={'#fff'} />
          </Box>
          <Spacer size={25} direction={'vertical'} />
          <Box width={'90%'}>
            <Text fontFamily="JioType-Black" fontSize={24} lineHeight={32} letterSpacing={-0.12}>
              Are you sure you want to logout?
            </Text>
          </Box>
          <ModBox pt={40} flexDirection="row" align="center" justifyContent={'space-between'}>
            <Box
              height={48}
              // maxWidth={148}
              flex={0.5}
              testID="logout"
              onPress={callLogoutApi}
              align={'center'}
              justify={'center'}
              underlayColor={'TRANSPARENT'}
              borderRadius={48}
              borderWidth={1}
              borderColor={'PRIMARY'}>
              {isLoggingOut ? (
                <Loader type={'small'} color="PRIMARY" />
              ) : (
                <NativeText
                  style={{ fontFamily: 'JioType-Bold', color: '#DF9F39', fontSize: 16 }}
                  numberOfLines={1}
                  ellipsizeMode="tail">
                  Yes, Logout
                </NativeText>
              )}
            </Box>
            <Spacer direction={'horizontal'} size={16} />
            <Box
              flex={0.5}
              // maxWidth={148}
              height={48}
              align={'center'}
              justify={'center'}
              underlayColor={convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions}
              borderRadius={48}
              testID="cancel-logout"
              onPress={handleCancel}
              bg={'PRIMARY'}>
              <Text title={'No'} fontFamily={'JioType-Bold'} fontSize={16} letterSpacing={-0.08} color={'WHITE'} />
            </Box>
          </ModBox>
        </Box>
      </ModalDialogNew>

      <ModalDialogNew
        show={showMidList}
        animate={mobileView ? true : false}
        type={mobileView ? 'bottom' : 'centeredWrap'}
        onDismiss={() => setMidListVisible(false)}
        backgroundColor="TRANSPARENT">
        <Box borderTopLeftRadius={24} borderTopRightRadius={24} bg="WHITE" overflow={'hidden'} pv={32} pb={10}>
          <Box ph={24} flexDirection={'row'} justifyContent="space-between" alignItems={'flex-start'} mb={22}>
            <Box width={'90%'}>
              <Text fontFamily="JioType-Black" fontSize={24}>
                {mobileView ? 'Switch Account' : 'Select Account'}
              </Text>
            </Box>
            <Box testID="close-midlist" onPress={() => setMidListVisible(false)} underlayColor={'TRANSPARENT'}>
              <SvgImage imageName="Close" />
            </Box>
          </Box>

          <RenderMidList setMidListVisible={setMidListVisible} merchantList={merchantList} mobileView={mobileView} />
        </Box>
      </ModalDialogNew>

      <ModalDialogNew
        show={showModal}
        animate={true}
        type="bottom"
        backgroundColor="TRANSPARENT"
        onBackPress={() => setShowModal(false)}>
        <VoiceBoxListModal onDismiss={(visible) => setShowModal(visible)} />
      </ModalDialogNew>
    </Box>
  )
}

const shadowStyle = {
  shadowColor: '#0c298a',
  shadowOffset: { width: 1, height: 8 },
  // backgroundColor: '#000',
  shadowOpacity: 0.6,
  shadowRadius: 80,
  borderRadius: 80,
  elevation: 8,
}

export const styles = {
  shadowStyle: (sOsMobile: boolean) => {
    if (sOsMobile) {
      return { ...shadowStyle } as BoxProps
    }
  },
  ripple1: {
    backgroundColor: 'BLACK',
    opacity: 0.05,
    width: 104,
    height: 104,
    borderRadius: 104,
    position: 'absolute',
  } as BoxProps,
  ripple2: {
    backgroundColor: 'BLACK',
    opacity: 0.05,
    width: 168,
    height: 168,
    borderRadius: 168,
    position: 'absolute',
  } as BoxProps,
  ripple3: {
    backgroundColor: 'BLACK',
    opacity: 0.03,
    width: 248,
    height: 248,
    borderRadius: 248,
    position: 'absolute',
  } as BoxProps,
  profileListWrapper: {
    backgroundColor: 'WHITE',
    paddingVertical: 25,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    position: 'absolute',
    bottom: 0,
    left: 0,
    pt: Platform.OS === 'ios' ? 45 : 25,
    width: '100%',
    zIndex: 4,
    overflow: 'auto',
  } as BoxProps,
  buttonBox: {
    flexDirection: 'row',
    bg: 'WHITE',
    pv: 16,
    align: 'center',
  } as BoxProps,
  labelText: (isLogout: boolean) =>
    ({
      fontWeight: '600',
      fontSize: 16,
      color: isLogout ? 'ERROR' : 'BLACK_21',
    } as TextProps),
  midBox: (isMobile = true) =>
    ({
      bg: 'WHITE',
      maxHeight: isMobile ? undefined : '90%',
      borderRadius: 4,
      minWidth: isMobile ? undefined : 450,
    } as BoxProps),
}

export default NewProfileNative
